<template>
  <div class="position-relative">
    <section class="section-shaped my-0">
      <div class="shape shape-style-1 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-2 text-white">Contact Us</h1>
              <h4 class="display-4 text-white">Let's Keep in Touch</h4>
              <p class="lead text-white">
                <a href="mailto:bayviewwis@gmail.com" target="_top">Email us</a>
                or follow us on social media.
                <a
                  class="nav-link nav-link-icon"
                  href="https://www.facebook.com/bayviewwis"
                >
                  <i class="fa fa-facebook-square"></i>
                  <span class="nav-link-inner--text">Facebook</span>
                </a>
                <a class="nav-link nav-link-icon" href="https://www.instagram.com/bayviewwis">
                  <i class="fa fa-instagram"></i>
                  <span class="nav-link-inner--text">Instagram</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>
